<template>
  <div>
    <div v-if="$mq === 'sm'">
      <footer-navigation
        :menus="menus"
        :currentMenu="currentMenu"
        :user="signedInUser"
        @onClickNextMenu="onClickNextMenu"
        @onClickMyPage="onClickMyPage"
        @onClickChangeOrganization="setSelectOrganizationModal(true)"
        @onClickSignOut="onClickSignOut"
      />
    </div>
    <div v-else>
      <side-navigation
        :menus="menus"
        :enabledChangeOrganization="organizations.length > 1"
        :collapsed="collapsed"
        :currentMenu="currentMenu"
        :currentOrganizationName="currentOrganization.name"
        :user="signedInUser"
        @onClickNextMenu="onClickNextMenu"
        @onClickMyPage="onClickMyPage"
        @onClickChangeOrganization="setSelectOrganizationModal(true)"
        @onClickSignOut="onClickSignOut"
      />
      <sub-side-navigation
        v-if="collapsed"
        :groupChats="groupChats"
      />
    </div>
    <proa-modal
      v-if="signedInUser"
      :modal="signOutModal"
      :title="$t('common.signOut')"
      @close="signOutModal = false"
    >
      <div class="mb-4">{{ $t('common.signOutConfirmMessage') }}</div>
      <div class="font-weight-w6 text-secondary mb-4">{{ $t('common.currentSignedInAccount') }}</div>
      <div class="d-flex flex-md-row flex-column align-items-center">
        <proa-avatar :src="signedInUser.meta.avatar || require('@/assets/images/avatar_default.png')"/>
        <div class="mt-2 mt-md-0 ml-md-4 d-flex flex-column justify-content-center align-items-center align-items-md-start">
          <div class="mb-1 font-weight-w6">{{ signedInUser.meta.displayName }}</div>
          <div>{{ signedInUser.email }}</div>
        </div>
      </div>
      <template slot="footer">
        <proa-button
          @click.native="signOutModal = false"
          class="default-button-width mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="onClickConfirmedSignOut"
          variant="secondary"
          class="default-button-width"
        >
          {{ $t('common.ok') }}
        </proa-button>
      </template>
    </proa-modal>
    <select-organization-modal v-if="organizations.length > 1"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import GroupChat from '@/store/models/GroupChat'
import Organization from '@/store/models/Organization'

import SelectOrganizationModal from '@/components/organisms/SelectOrganizationModal'
import SideNavigation from '@/components/molecules/SideNavigation'
import SubSideNavigation from '@/components/molecules/SubSideNavigation'
import FooterNavigation from '@/components/molecules/FooterNavigation'

export default {
  name: 'Navigation',
  components: {
    SelectOrganizationModal,
    SideNavigation,
    SubSideNavigation,
    FooterNavigation
  },
  props: {
    collapsed: Boolean
  },
  computed: {
    menus: function() {
      let defaultMenus = [
        {
          name: 'mySpace'
        },
        {
          name: 'chat'
        },
        {
          name: 'meeting'
        },
        {
          name: 'member'
        }
      ]
      if (this.$mq === 'sm') {
        let otherMenu = {
          name: 'other',
          subMenus: [{
            name: 'myPage'
          }]
        }
        if (this.currentLicensedPlan.allowProjects) {
          otherMenu.subMenus.push(
            {
              name: 'project'
            }
          )
        }
        if (this.currentOrganization.adminUserId === this.signedInUser.id) {
          otherMenu.subMenus.push(
            {
              name: 'management'
            }
          )
        }
        if (this.organizations.length > 1) {
          otherMenu.subMenus.push(
            {
              name: 'changeOrganization'
            }
          )
        }
        otherMenu.subMenus.push(
          {
            name: 'signOut'
          }
        )
        return defaultMenus.concat(otherMenu)
      } else {
        if (this.currentLicensedPlan.allowProjects) {
          defaultMenus = defaultMenus.concat({
            name: 'project'
          })
        }
        if (this.currentOrganization.adminUserId === this.signedInUser.id) {
          defaultMenus = defaultMenus.concat({
            name: 'management'
          })
        }
        return defaultMenus
      }
    },
    groupChats: function() {
      return GroupChat.listables()
    },
    organizations: function() { return Organization.all() },
    ...mapGetters({
      currentMenu: 'menu',
      signedInUser: 'auth/signedInUser',
      currentOrganization: 'auth/currentOrganization',
      currentLicensedPlan: 'auth/currentLicensedPlan'
    })
  },
  data() {
    return {
      signOutModal: false
    }
  },
  methods: {
    onClickNextMenu: function(nextMenu) {
      if (this.$route.name === nextMenu) return
      this.$router.push({ name: nextMenu })
    },
    onClickMyPage: function() {
      if (this.$route.name == 'showMember' && this.$route.params.id == this.signedInUser.id) return
      this.$router.push({ name: 'showMember', params: { id: this.signedInUser.id } })
    },
    onClickSignOut: function() {
      this.signOutModal = true
    },
    onClickConfirmedSignOut: function() {
      this.signOut()
    },
    ...mapMutations({
      setSelectOrganizationModal: 'setSelectOrganizationModal'
    }),
    ...mapActions({
      signOut: 'auth/signOut',
      apiGetGroupChats: 'entities/groupChats/index'
    })
  },
  created() {
    if (this.collapsed) this.apiGetGroupChats()
  },
  watch: {
    collapsed: function(value) {

      /** NOTE
       * 現状はチャット詳細のみダブルサイドナビゲーションを採用
       */
      if (value && !this.groupChats.length) {
        this.apiGetGroupChats()
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
